import { LightningElement, api, track } from 'lwc';




export default class sldsExpandableSection extends LightningElement {
    static renderMode = 'light';

    @api title;
    @track isCustomButton = false;
    @track listBoxOptions;

    @api 
    set propertiesObj(value) {
        this._propertiesObj = value;
        // If is 'customButtonsIconsListBox' (i.e. x-custom-button-icons-list-box) --> reactively update the array
        if (value.customButtonsIconsListBox) { 
            this.listBoxOptions = value.options.map(opt => { 
                return {...opt}; 
            }); 
        } 
    }
    get propertiesObj() {
        return this._propertiesObj;
    }

    renderedCallback() {
        if (this._propertiesObj.customButtonsIconsListBox) {
            const button = this.querySelector('slds-section__title-action');
            const title = this.querySelector('slds-section__title');
            if (button && title) {
                button.style.height = '25px';
                button.style.fontSize = '12px';
            }
        } 
    }

    toggleSection(event) {
        const expandableSection = this.querySelector('.slds-section');
        const sectionContent = this.querySelector('.slds-section__content');

        if (expandableSection && expandableSection.classList.contains('slds-is-open')) {
            expandableSection.classList.remove('slds-is-open');
            event.target.setAttribute("aria-expanded", "false");
            if (sectionContent) {
                sectionContent.setAttribute("aria-hidden", "true");
            }
            return;
        }

        expandableSection.classList.add('slds-is-open');
        event.target.setAttribute("aria-expanded", "true");
        if (sectionContent) {
            sectionContent.setAttribute("aria-hidden", "false");
        }

    }

}